import Header from "./components/Header";
import Banner from "./components/Banner";
import BackgroundImageComponent from './components/BackgroundImageComponent';
import About from "./components/About";
import Services from "./components/Services";
import Scholarship from "./components/Scholarship";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function App() {
  return (
    <>
    <Header/>
   <BackgroundImageComponent/>
    <Banner/>
    <About/>
    <Services/>
    <Scholarship/>
    <Contact/>
    <Footer/>


    
  
    </>
  )
}